import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {PartsRequestReturnBasketItem} from '../../metadaWarehousePartsRequestReturnBasket/types';
import {BaseDirectSaleLabourItem, BaseDirectSaleMaterialItem} from '../types';

const getDirectSaleMaterialBasketItemMock: BaseDirectSaleMaterialItem[] = [
  {
    id: 'd3953ddb-4d26-4292-82dd-919d8d7196e5',
    warehouse_id: '855bd140-6054-4d4b-beeb-2adbf5ee89b4',
    itemEditingAllowed: true,
    priceType: 'SALES_BASE_PRICE',
    requestType: 'Request',
    name: 'TEST article',
    manufacturerNumber: 'TEST',
    manufacturerId: '04911c52-e6fc-11ee-bd3d-0242ac120002',
    quantity: 1,
    unit: 'bbc793ad-2b9d-4d0a-88a6-ae0cd6855409',
    dispensingUnit: 1,
    quantityEditingAllowed: true,
    minMaxQuantity: {
      minQuantity: 1,
      maxQuantity: null,
    },
    unitPrice: {
      withoutVat: {
        amount: 555.56,
        currency: 'EUR',
      },
      withVat: {
        amount: 672.23,
        currency: 'EUR',
      },
    },
    discount: {
      rate: 0,
      withoutVat: {
        amount: 0,
        currency: 'EUR',
      },
      withVat: {
        amount: 555.56,
        currency: 'EUR',
      },
    },
    totalPrice: {
      withoutVat: {
        amount: 555.56,
        currency: 'EUR',
      },
      withVat: {
        amount: 672.23,
        currency: 'EUR',
      },
    },
    tooltip: [
      {
        label: 'Request type',
        value: 'Request',
      },
    ],
  },
];

const getDirectSaleLabourBasketItemMock: BaseDirectSaleLabourItem[] = [
  {
    id: '41fd7697-9444-4800-b706-81a3e8486433',
    itemEditingAllowed: true,
    priceType: 'SVCPRICETYPE_DIRECT_PRICE',
    priceTypeName: 'SVCPRICETYPE_DIRECT_PRICE',
    name: 'Technical control',
    number: 'DPTC2',
    labourCatalog: {
      id: '1ccbb029-4655-416c-b553-1da570bd9ae0',
      category: {
        id: '84e49d21-bac5-4e04-8cc4-f29f3ff397a0',
        name: 'Labour Catalogue',
      },
    },
    quantity: 1,
    unit: 'SVCUNIT_PCS',
    quantityEditingAllowed: true,
    unitPrice: {
      withoutVat: {
        amount: 4999,
        currency: 'CZK',
      },
      withVat: {
        amount: 6048.79,
        currency: 'CZK',
      },
    },
    discount: {
      rate: 0,
      withoutVat: {
        amount: 0,
        currency: 'CZK',
      },
      withVat: {
        amount: 0,
        currency: 'CZK',
      },
    },
    totalPrice: {
      withoutVat: {
        amount: 4999,
        currency: 'CZK',
      },
      withVat: {
        amount: 6048.79,
        currency: 'CZK',
      },
    },
    tooltip: [
      {
        label: 'Type',
        value: 'Direct price',
      },
      {
        label: 'Work type',
        value: 'Diagnostik',
      },
      {
        label: 'Allowing discounts',
        value: 'Yes',
      },
      {
        label: 'MULO units',
        value: '-',
      },
    ],
  },
];

const getDirectSaleMaterialReturnBasketItemMock: PartsRequestReturnBasketItem[] = [
  {
    id: '7f90c5be-8bc7-4a6e-9544-bc1a07df8fbd',
    name: 'MG001',
    manufacturerNumber: 'MG001',
    warehouseId: '82667c95-f9bb-4e87-9ffe-c99331399a7b',
    manufacturerId: '04911c52-e6fc-11ee-bd3d-0242ac120002',
    quantity: 1,
    unit: 'a324d039-94b2-4b40-8298-b55cadb7c613',
    dispensingUnit: 1,
    itemEditingAllowed: false,
    quantityEditingAllowed: true,
    unitPrice: {
      withoutVat: {
        amount: 100,
        currency: 'CZK',
      },
      withVat: {
        amount: 121,
        currency: 'CZK',
      },
    },
    totalPrice: {
      withoutVat: {
        amount: 100,
        currency: 'CZK',
      },
      withVat: {
        amount: 121,
        currency: 'CZK',
      },
    },
    tooltip: [
      {
        label: 'Request type',
        value: '-',
      },
    ],
    minMaxQuantity: {
      minQuantity: 1,
      maxQuantity: 10,
    },
  },
];

const bulkPatchDirectSaleLabourBasketItemsInterceptor = (server: SetupServerApi) =>
  server.use(
    http.patch('*/warehouse/v1/direct-sale/*/item-labour/edit', () => HttpResponse.json())
  );

export const metadaWarehouseDirectSaleBasketItemApiMock = {
  getDirectSaleMaterialBasketItemMock,
  getDirectSaleLabourBasketItemMock,
  getDirectSaleMaterialReturnBasketItemMock,
  bulkPatchDirectSaleLabourBasketItemsInterceptor,
};
